import { render, staticRenderFns } from "./FloatingBack.vue?vue&type=template&id=bd51b1c4&scoped=true"
import script from "./FloatingBack.vue?vue&type=script&lang=js"
export * from "./FloatingBack.vue?vue&type=script&lang=js"
import style0 from "./FloatingBack.vue?vue&type=style&index=0&id=bd51b1c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd51b1c4",
  null
  
)

export default component.exports